module.exports = __webpack_public_path__ + "static/media/coverimg.9527de02.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/coverimg.jpg
 ** module id = 435
 ** module chunks = 0
 **/